@file:OptIn(InternalResourceApi::class)

package rapidreader.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/rapidreader.composeapp.generated.resources/"

@delegate:ResourceContentHash(715_645_070)
internal val Res.font.bold: FontResource by lazy {
      FontResource("font:bold", setOf(
        ResourceItem(setOf(), "${MD}font/bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_674_837_385)
internal val Res.font.medium: FontResource by lazy {
      FontResource("font:medium", setOf(
        ResourceItem(setOf(), "${MD}font/medium.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(539_246_146)
internal val Res.font.regular: FontResource by lazy {
      FontResource("font:regular", setOf(
        ResourceItem(setOf(), "${MD}font/regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(746_511_900)
internal val Res.font.semi_bold: FontResource by lazy {
      FontResource("font:semi_bold", setOf(
        ResourceItem(setOf(), "${MD}font/semi_bold.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("bold", Res.font.bold)
  map.put("medium", Res.font.medium)
  map.put("regular", Res.font.regular)
  map.put("semi_bold", Res.font.semi_bold)
}
